import { request } from './api';

export const benefits = (data) => {
    return request(`/statistics/benefits/issued`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const games = (data) => {
    return request(`/statistics/games`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const notPlayed = (data) => {
    return request(`/statistics/participants/not_played`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const participants = (data) => {
    return request(`/statistics/participants`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const commitedGamesOfParticipants = (data) => {
    return request(`/statistics/participants/games`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const gamesAverage = (data) => {
    return request(`/statistics/games/average`, {
        method: 'POST',
        body: JSON.stringify(data)
    });
};
